module.exports = __webpack_public_path__ + "static/img/2s-design-b4.70accf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-design-b4.jpg
// module id = WAnI
// module chunks = 0